import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../../Services/Basequerywithreauth";

export const authService = createApi({
  reducerPath: "authService",
  baseQuery: createBaseQueryWithReauth(),
  endpoints: (builder) => ({
    userCheck: builder.query({
      query: () => ({
        url: "user-check",
        method: "POST",
        body: {},
        credentials: "include",
      }),
    }),
  }),
});

export const {
  useUserCheckQuery
} = authService;